import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import './ModalCajaFlujoConcepto.css';
import Loader from '../Loader/Loader';

const ModalCajaCategoriaMovimiento = ({ onSave, onClose, isOpen, categoriaMovimientoEditar }) => {
  const [loading, setLoading] = useState(false);

  const getInitialState = () => ({
    nombre_categoria_movimiento: '',
    tipo: ''
  });

  const [formData, setFormData] = useState(getInitialState());

  useEffect(() => {
    if (isOpen) {
      if (categoriaMovimientoEditar) {
        setFormData({
          nombre_categoria_movimiento: categoriaMovimientoEditar.nombre_categoria_movimiento || '',
          tipo: categoriaMovimientoEditar.tipo || ''
        });
      } else {
        setFormData(getInitialState());
      }
    }
  }, [isOpen, categoriaMovimientoEditar]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);

      if (!formData.nombre_categoria_movimiento.trim()) {
        alert('El nombre de la categoría de movimiento es requerido');
        setLoading(false);
        return;
      }

      if (!formData.tipo) {
        alert('El tipo es obligatorio');
        setLoading(false);
        return;
      }

      await onSave({
        nombre_categoria_movimiento: formData.nombre_categoria_movimiento.trim(),
        tipo: formData.tipo
      });
      onClose();
    } catch (error) {
      console.error("Error al guardar:", error);
      const errorMsg = error.response?.data?.message || 'Ocurrió un error al guardar.';
      alert(`Error: ${errorMsg}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} className="custom-modal" backdrop="static">
      <ModalHeader className="modal-header">
        <div className="titulo">
          <h1>{categoriaMovimientoEditar ? 'EDITAR CATEGORÍA DE MOVIMIENTO' : 'AGREGAR CATEGORÍA DE MOVIMIENTO'}</h1>
          <Button className="close-btn" onClick={onClose}>X</Button>
        </div>
      </ModalHeader>
      <div className="modal-body-footer">
        {loading ? (
          <Loader />
        ) : (
          <ModalBody className="modal-body">
            <Form className="fila" onSubmit={(e) => e.preventDefault()}>
              <FormGroup>
                <Label>Nombre:</Label>
                <Input
                  className="form-control"
                  type="text"
                  name="nombre_categoria_movimiento"
                  value={formData.nombre_categoria_movimiento}
                  onChange={handleChange}
                  placeholder="Ingrese el nombre de la categoría"
                  maxLength="255"
                  required
                />
              </FormGroup>

              <FormGroup>
                <Label>Tipo:</Label>
                <Input
                  className="form-control"
                  type="select"
                  name="tipo"
                  value={formData.tipo}
                  onChange={handleChange}
                  required
                >
                  <option value="">Seleccione...</option>
                  <option value="ingreso">Ingreso</option>
                  <option value="egreso">Egreso</option>
                </Input>
              </FormGroup>

              <FormGroup>
                <div className="button-container">
                  <Button
                    className="button-custom"
                    onClick={handleSubmit}
                    disabled={loading}
                  >
                    {categoriaMovimientoEditar ? 'ACTUALIZAR' : 'GUARDAR'}
                  </Button>
                </div>
              </FormGroup>
            </Form>
          </ModalBody>
        )}
      </div>
    </Modal>
  );
};

export default ModalCajaCategoriaMovimiento;
